export function isItTestEnvironment() {
    return (window.location.href.indexOf('http://localhost') > -1 || window.location.href.indexOf('http://happy-table-admin-test') > -1 || window.location.href.indexOf('https://testadmin') > -1) ? true : false;
}